import BoxTitle from "@/routes/org/_components/box-title"
import MixedLineBarChart from "@/routes/org/_components/weekly/mixed-line-bar-chart"
import { langStore } from "@/stores/lang-store"
import Wrapper from "@/components/wrapper"
import { weeklyBundle } from "./weekly-const"

// ! 현재 고정 데이터를 사용하고 있기 때문에 이후에 fetching을 통한 데이터 가져오기 필요
const WeeklyLeakageTrendsView = () => {
  const lang = langStore((s) => s.lang)
  const weeklyLeakageTrendsData = {
    xLabels: [
      "2025-10-25",
      "2025-10-26",
      "2025-10-27",
      "2025-10-28",
      "2025-10-29",
      "2025-10-30",
      "2025-10-31"
    ],
    ySeries: [
      {
        name: weeklyBundle.legends[0][lang],
        data: [2147.862, 2130.796, 2066.248, 2079.93, 3073.431, 3164.399, 2177.861],
        color: "#1dd3b0"
      },
      {
        type: "line",
        name: weeklyBundle.legends[1][lang],
        data: [2270, 2270, 2338, 2290, 2311, 2238, 2238],
        color: "#affc41",
        tooltip: { unit: weeklyBundle.unit.household[lang] }
      }
    ],
    leftLabel: weeklyBundle.labels[0][lang],
    rightLabel: weeklyBundle.labels[1][lang]
  }

  return (
    <Wrapper.shadow>
      <BoxTitle title={weeklyBundle.title[lang]} />
      <MixedLineBarChart datasets={weeklyLeakageTrendsData} />
    </Wrapper.shadow>
  )
}

export default WeeklyLeakageTrendsView
